import moment from 'moment';
import { Component, Input, Output, EventEmitter, OnChanges, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { DateLockFactory } from '@shared/factories/date-lock/date-lock.factory';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { RegisterMixtapeService } from '@shared/services/register-mixpanel/register-mixtape.service';
import { cloneDeep } from 'lodash';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { InputDateComponent } from '../input-date/input-date.component';
import { TooltipModule } from 'primeng/tooltip';
import { TooltipLawComponent } from '../tooltip-law/tooltip-law.component';
import { TooltipInfoComponent } from '../tooltip-info/tooltip-info.component';
import { NgClass } from '@angular/common';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { TimePickerComponent } from '../time-picker/time-picker.component';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import { FromToCalendarComponent } from '../from-to-calendar/from-to-calendar.component';
import { TooltipInReportComponent } from "../tooltip-in-report/tooltip-in-report.component";
import { FieldSequentialHeaderComponent } from "../field-sequential-header/field-sequential-header.component";
@Component({
    selector: 'field-type-date',
    templateUrl: './field-type-date.component.html',
    standalone: true,
    imports: [
    NgClass,
    TooltipInfoComponent,
    TooltipLawComponent,
    TooltipModule,
    InputDateComponent,
    AfTranslateDirective,
    AfTranslatePipe,
    OverlayPanelModule,
    TimePickerComponent,
    CalendarModule,
    FormsModule,
    FromToCalendarComponent,
    TooltipInReportComponent,
    FieldSequentialHeaderComponent
]
})
export class FieldTypeDateComponent implements OnChanges, AfterViewInit {
  isLanding: boolean = this.customLanding.isLanding();
  fieldTypeDate:any = {
    type: 'date',
    showButton: false,
    hours: 0,
    minutes: 0
  };
  @Input() field:any;
  @Input() preSelectItem:any;
  @Input() alertHour:any;
  @Input() concept:any;
  @Input() public:any;
  @Output() itemSelected = new EventEmitter();
  @Output() createAlert = new EventEmitter();
  @Output() openRelatedInfo = new EventEmitter();
  @ViewChild('containerFieldDate') containerFieldDateElement: ElementRef;
  @ViewChild('calendarFieldDateOverlay') calendarFieldDateOverlay: OverlayPanel;
  @ViewChild('clockFieldDateOverlay') clockFieldDateOverlay: OverlayPanel;

  constructor(private customLanding:CustomLandingFactory,
    private commonUtilsService:CommonUtilsService,
    private modalService:ModalServiceService,
    private loader:LoaderFactory,
    private registerService:RegisterMixtapeService,
    private translate:AfTranslateFactory,
    private dateLock:DateLockFactory
  ){}

  ngAfterViewInit(): void {
    this.commonUtilsService.bindScrollOverlayListener(this.calendarFieldDateOverlay);
    this.commonUtilsService.bindScrollOverlayListener(this.clockFieldDateOverlay);
  }

  ngOnChanges(): void {
    let that = this.fieldTypeDate;
    let field = this.field;
    if (field) {
      field.public = this.public;
      that.titleField = field.label;
      field.id = !field.id? this.commonUtilsService.createId(): field.id;
      if(field.extendedLabel && field.extendedLabel !== ''){
        that.titleField = field.extendedLabel;
      }
      field.id = field.generateId || !field.fieldId?this.commonUtilsService.createId() : field.fieldId;

      if (field.datePickerOptions) {
        for (let [key, value] of Object.entries(field.datePickerOptions)) {
          this.fieldTypeDate.datePickerOptions[key] = value;
        }
      }

      let preSelectItem = this.preSelectItem;
      if(preSelectItem){
        that.hours = preSelectItem.getHours();
        that.minutes = preSelectItem.getMinutes();
      }else{
        preSelectItem = null;
        that.hours = 0;
        that.minutes = 0;
      }
      if(field.fromTo){
        if(preSelectItem && preSelectItem.indexOf('-') !== -1){
          let dates : any = preSelectItem.split(' - ');
          that.creationDateFromDate = this.commonUtilsService.convertShortDate(dates[0]);
          that.creationDateToDate = this.commonUtilsService.convertShortDate(dates[1]);
        }else{
          that.creationDateFromDate = null;
          that.creationDateToDate = null;
        }
      }else{
        this.configureMaxAndMinDate();
      }
      if(field.inReport !== null && field.inReport !== undefined){
        this.fieldTypeDate.inReport = field.inReport.indexOf('|') === -1? [field.inReport] : field.inReport.split('|')
      }
    }
  }

  changeItemSelected(newValue:string){
    this.itemSelected.emit({ newValue: newValue });
  }

  configureMaxAndMinDate(){
    let today     : any = moment();
    let tomorrow  : any = moment().add(1,'days');
    let yesterday : any = moment().add(-1, 'days');
    switch(this.field.dateLockType){
      case 1:
        this.fieldTypeDate.minDate = new Date(today);
        break;
      case 2:
        this.fieldTypeDate.minDate = new Date(tomorrow);
        break;
      case 3:
        this.fieldTypeDate.maxDate = new Date(today);
        break;
      case 4:
        this.fieldTypeDate.maxDate = new Date(yesterday);
        break;
    }
  }


  openModalRelatedInfo(e:any){
    e.stopPropagation();
    e.preventDefault();
    this.openRelatedInfo.emit({relatedInfo: this.field.relatedInfo});
  }

  changeOpenDataPicker(){
    this.field.fromTo ? this.fieldTypeDate.openFromToPicker = !this.fieldTypeDate.openFromToPicker : this.fieldTypeDate.openDatePicker = !this.fieldTypeDate.openDatePicker;
  }

  openAddAlert(){
    let that = this.fieldTypeDate;
    if(!this.field.noEditable){
        let configuration = {
          from: 'fieldTypeDate',
          type: that.type,
          defaultHour: this.alertHour,
          concept: this.concept
        };
        this.modalService.addAlert(configuration).subscribe((result:any) => {
          if(result.result === 'ok'){
            this.loader.openLoader('create-alert-field-item');
            this.createAlert.emit({alert: result});
            let registerItem:any = {
              event: 'create alert',
              alertType: that.type,
              conceptName: sessionStorage.getItem('breadcrumbConcept') + this.concept.title
            }
            this.registerService.register(registerItem);
          }
        });
    }
  }

  changeInTimePicker(event:any){
    let that = this.fieldTypeDate;
    let changeTime = event.hours !== 0 || event.hours !== that.hours || event.minutes !== 0 || event.minutes !== that.minutes;
    that.hours = event.hours;
    that.minutes = event.minutes;
    if(changeTime){
      this.changeInField('time');
    }
  }

  changeDatePicker(newValue:any){
    this.changeInField('date-picker');
    this.calendarFieldDateOverlay.hide();
  }

  changeInField(type:string='') {
    let that = this.fieldTypeDate;
    this.field.errorInDateLock = false;
    if(this.preSelectItem){
      let dateSelected = cloneDeep(this.preSelectItem);
      delete this.preSelectItem;
      if(type === 'time'){
        if(that.hours && that.minutes){
          dateSelected.setHours(that.hours, that.minutes);
        }else{
          dateSelected.setHours(0, 0);
        }
      }else if(type ==='date-picker'){
        if(this.field.showTime){
          dateSelected.setHours(that.hours, that.minutes);
        }else{
          dateSelected.setHours(0, 0, 0, 0);
        }
      }else{
        that.hours = dateSelected.getHours();
        that.minutes = dateSelected.getMinutes();
      }
      this.preSelectItem = dateSelected;
      this.checkDateLock();
    }else if(type === 'time'){
      this.preSelectItem = new Date(new Date().setHours(that.hours, that.minutes, 0, 0));
      this.checkDateLock();
    }
    if(this.preSelectItem){
      this.field.error = false;
    }
    this.changeItemSelected(this.preSelectItem);
  }

  changeCalendar(event:any){
    let dates: any = event.dates;
    if(dates.type === 'apply'){
      this.preSelectItem = dates.from.format('DD/MM/YYYY')+' - '+dates.to.format('DD/MM/YYYY');
      this.fieldTypeDate.creationDateFromDate = dates.from;
      this.fieldTypeDate.creationDateToDate = dates.to;
    }else if(dates.type === 'restore'){
      this.preSelectItem = '';
      this.fieldTypeDate.creationDateFromDate = null;
      this.fieldTypeDate.creationDateToDate = null;
    }
    // setTimeout(()=>{
      if(dates.type !== 'cancel'){
        this.changeItemSelected(this.preSelectItem);
      }
      this.calendarFieldDateOverlay.hide();
    // })
  }

  outputDate(e:any){
    let that = this.fieldTypeDate;
    let dateValue: any = e.value;
    let isValid: boolean = e.isValid;
    this.field.errorInDateLock = false;
    that.errorText ='';
    this.preSelectItem = dateValue;
    if(dateValue && isValid){
      this.preSelectItem = new Date(dateValue);
      that.time = moment(dateValue);
      this.changeInField();
    }else if(!isValid){
      that.errorText = this.translate.instant('field-type-date.invalid-date');
      this.field.errorInDateLock = true;
      this.configureErrorInDateLock();
    }
  }

  configureErrorInDateLock(){
    this.field.errorInDateLock ? this.dateLock.addErrors(this.field) : this.dateLock.deleteError(this.field);
    if(this.concept){
      this.configureErrorConcept();
    }
  }

  configureErrorConcept(){
    this.field.errorInForm = this.field.errorInDateLock;
    this.commonUtilsService.configureConceptErrorForm(this.field, this.concept);
  }

  checkDateLock(){
    let that = this.fieldTypeDate;
    let today : any = moment().format('MM-DD-YYYY');
    let preselect : any = moment(this.preSelectItem).format('MM-DD-YYYY');
    switch(this.field.dateLockType){
      case 1:
        this.field.errorInDateLock = moment(preselect).isBefore(today);
        that.errorText = this.translate.instant('field-type-date.error-date-before');
        break;
      case 2:
        this.field.errorInDateLock = (moment(preselect).isBefore(today) || (moment(preselect).isSame(today)));
        that.errorText = this.translate.instant('field-type-date.error-date-before-today');
        break;
      case 3:
        this.field.errorInDateLock = moment(preselect).isAfter(today);
        that.errorText = this.translate.instant('field-type-date.error-date-after');
        break;
      case 4:
        this.field.errorInDateLock = (moment(preselect).isAfter(today) || (moment(preselect).isSame(today)));
        that.errorText = this.translate.instant('field-type-date.error-date-after-today');
        break;
    }
    this.configureErrorInDateLock();
  }

  deleteValueField(){
    if (this.field.fromTo) {
      this.fieldTypeDate.creationDateFromDate = null;
      this.fieldTypeDate.creationDateToDate = null;
    }
    this.preSelectItem = null;
    this.fieldTypeDate.hours = 0;
    this.fieldTypeDate.minutes = 0;
    // this.fieldTypeDate.selectInput = 'text';
    this.field.error = false;
    this.field.errorInDateLock = false;
    this.configureErrorInDateLock();
    this.changeItemSelected(this.preSelectItem);
  }

  toggleFilter(e: any, type:any){
    this.commonUtilsService.toggleFilterOverlay(e, type, 'overlay', this.containerFieldDateElement.nativeElement);
  }
}
